<script setup lang="ts">
import type { DynamicAuctionItemDetails } from '@autobid/strapi-integration/rest/components'
import type { Ref } from 'vue'
import { useMyPreviewMode } from '@autobid/ui/composables/useMyPreviewMode'
import { CAR_PREVIEW_PDF_ID } from '@autobid/ui/constants/CAR_PREVIEW_PDF_ID'
import { getIdFromSlug } from '@autobid/ui/utils/car/getIdFromSlug'

interface Props {
  data: DynamicAuctionItemDetails
}

const props = defineProps<Props>()
const route = useRoute()
const { enabled: isPreview } = useMyPreviewMode()
const slug = isPreview.value ? '' : route.params.slug.toString()
const carId = useState('carId') as Ref<number>
carId.value = isPreview.value ? CAR_PREVIEW_PDF_ID : getIdFromSlug(slug)
</script>

<template>
  <SectionsDetails v-bind="props.data" />
</template>
